import React, { useState } from "react";
import { Box } from "@mui/material";
import { useIntl } from "react-intl";
import DAppTrackingContent from "./components/DAppTrackingContent";
import { useParams } from "react-router-dom";

const DAppTracking = () => {
  const { formatMessage } = useIntl();
  const [value, setValue] = useState(0);
  const { subEntityName } = useParams();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <div className="fade-up">
        <Box className="title" mb={1}>
          {subEntityName && <>{subEntityName} - </>}
          {formatMessage({ id: "dappTracking.header.title" })}
        </Box>
        <Box color={(theme) => theme.customColors.grey[600]} mb={1}>
          {formatMessage({ id: "dappTracking.header.description" })}
        </Box>
        <Box className="startRow" sx={{ color: "#A5A5A5" }} mb={3}>
          <i className="meta-crm-icon-ic_info font-size-14 mgr4" />
          {formatMessage({ id: "global.tooltip.timeZone" })}
        </Box>
      </div>
      <div className="fade-up-more">
        <DAppTrackingContent />
      </div>
    </>
  );
};

export default DAppTracking;
